import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "self-center text-center space-y-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "*Claims initiated prior to 2021 may be combined or have incomplete data", -1)
const _hoisted_6 = { class: "content-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Start a Claim ")
const _hoisted_8 = {
  key: 0,
  class: "mt-6 text-center text-capDarkPurple"
}
const _hoisted_9 = {
  key: 1,
  class: "space-y-3 mt-3"
}
const _hoisted_10 = { class: "flex items-center justify-between gap-4 pb-2 mb-2 border-b border-capGrey border-opacity-30 text-base" }
const _hoisted_11 = { class: "flex items-center gap-x-8 gap-y-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-1" }, "Claim #", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-1" }, "Claim Type", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-1" }, "Claim Date", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-1" }, "Invoice Received", -1)
const _hoisted_16 = { class: "grid md:grid-cols-3 lg:grid-cols-5 gap-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Service Status", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Authorization #", -1)
const _hoisted_19 = { class: "lg:col-span-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Amount Approved", -1)
const _hoisted_21 = {
  key: 0,
  class: "mt-3 space-y-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Claim Payment Status", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Pay To", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Amount", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Pay Date", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Ref #", -1)
const _hoisted_27 = {
  key: 1,
  class: "grid md:grid-cols-3 lg:grid-cols-5 gap-3 mt-3"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Claim Payment Status"),
  /*#__PURE__*/_createElementVNode("div", null, "—")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Pay To"),
  /*#__PURE__*/_createElementVNode("div", null, "—")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Amount", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Pay Date"),
  /*#__PURE__*/_createElementVNode("div", null, "—")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Ref #"),
  /*#__PURE__*/_createElementVNode("div", null, "—")
], -1)

import { computed } from 'vue';
    import { useStore } from 'vuex';
    import { useCurrency } from '@/composables/useCurrency';
    import { splitAddressLabel } from '@/composables/useAddressLabel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ContractClaims',
  setup(__props) {

    const store = useStore()
    const user = computed(() => store.state.user)
    const contract = computed(() => store.state.contract)
    const addressLabel = computed(() => splitAddressLabel(contract.value.zctWebPhysicalAddressLabel))
    const claimList = computed(() => store.state.claimList)

    const isActive = computed(() => {
        if (!contract.value.activeDate) return true
        const activeDate = new Date(contract.value.activeDate)
        if (isNaN(activeDate.getTime())) return true
        activeDate.setHours(0, 0, 0, 0)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        return today >= activeDate
    })

    function startClaim() {
        window.open('https://www.completehomewarranty.com/request-service/', '_blank')
    }

    function getClaimPayments(claim: any) {
        const raw = claim?.zctPaymentArray
        if (!raw) return []
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Object.values(parsed).map((payment: any) => ({
            id: payment['ID'],
            payTo: payment['Pay To'],
            amount: payment['Amount'],
            datePaid: payment['Date Paid'],
            ref: payment['Ref'],
            status: payment['Status'],
            paymentType: payment['Payment Type'],
        }))
    }

    const defaultCurrency = computed(() =>
        user.value?.currencyCode ??
        (user.value?.country === 'CA' ? 'CAD' : 'USD')
    )

    const defaultLocale = computed(() =>
        user.value?.locale ?? (defaultCurrency.value === 'CAD' ? 'en-CA' : 'en-US')
    )

    const { formatMoney } = useCurrency({
        defaultCurrency: defaultCurrency.value,
        locale: defaultLocale.value
    })

return (_ctx: any,_cache: any) => {
  const _component_c_container_heading = _resolveComponent("c-container-heading")!
  const _component_c_badge = _resolveComponent("c-badge")!
  const _component_c_container_text = _resolveComponent("c-container-text")!
  const _component_c_button = _resolveComponent("c-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_c_container_heading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(contract).contractNumberDisplay), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_c_badge, {
            status: _unref(contract).status
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(contract).status), 1)
            ]),
            _: 1
          }, 8, ["status"])
        ]),
        _createVNode(_component_c_container_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(addressLabel).street), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_c_container_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(addressLabel).cityStateZip), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_c_container_text, {
          class: "mt-3",
          secondary: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('Active on ' + _unref(contract).activeDate), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(contract).status === 'Past Due')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "*Invoices will not be paid until accounts are brought current"))
          : _createCommentVNode("", true),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(isActive))
          ? (_openBlock(), _createBlock(_component_c_button, {
              key: 0,
              onClick: startClaim
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_unref(claimList).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No claims have been initiated. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(claimList), (claim, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: claim.__kptID + ' + ' + index,
              class: "border-2 border-capGrey border-opacity-50 rounded-md p-3"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(claim.claimNumber || '—'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(claim.item || '—'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(claim.claimDate || '—'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString(_unref(contract).completionDate || '—'), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_c_badge, {
                    status: claim.status
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(claim.status || '—'), 1)
                    ]),
                    _: 2
                  }, 1032, ["status"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", null, _toDisplayString(claim.serviceStatus || '—'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(claim.authorizationNumber || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(claim.zcnLineItemTotal ?? 0)), 1)
                ])
              ]),
              (getClaimPayments(claim).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getClaimPayments(claim), (payment, pIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: payment.id || pIndex,
                        class: "grid md:grid-cols-3 lg:grid-cols-5 gap-3 pt-2 border-t border-capGrey border-opacity-20 first:border-t-0 first:pt-0"
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_22,
                          _createElementVNode("div", null, _toDisplayString(payment.status || '—'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_23,
                          _createElementVNode("div", null, _toDisplayString(payment.payTo || '—'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_24,
                          _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(payment.amount || 0)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_25,
                          _createElementVNode("div", null, _toDisplayString(payment.datePaid || '—'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_26,
                          _createElementVNode("div", null, _toDisplayString(payment.ref || '—'), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    _createElementVNode("div", null, [
                      _hoisted_30,
                      _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(0)), 1)
                    ]),
                    _hoisted_31,
                    _hoisted_32
                  ]))
            ]))
          }), 128))
        ]))
  ]))
}
}

})